"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadlineLine = exports.BodyTextLine = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const design_system_1 = require("@servicetitan/design-system");
const use_client_rect_1 = require("../../../utils/use-client-rect");
const Styles = __importStar(require("./line-text.module.less"));
const useLimited = () => {
    const [rect1, ref1] = use_client_rect_1.useClientRect();
    const [rect2, ref2] = use_client_rect_1.useClientRect();
    const limited = react_1.useMemo(() => !!(rect1 === null || rect1 === void 0 ? void 0 : rect1.width) && !!(rect2 === null || rect2 === void 0 ? void 0 : rect2.width) && ((rect2 === null || rect2 === void 0 ? void 0 : rect2.width) || 0) > ((rect1 === null || rect1 === void 0 ? void 0 : rect1.width) || 0), [rect1, rect2]);
    return [ref1, ref2, limited];
};
const BodyTextLine = (_a) => {
    var { children, wrapperClassName } = _a, props = __rest(_a, ["children", "wrapperClassName"]);
    const [ref1, ref2, limited] = useLimited();
    return (jsx_runtime_1.jsxs("div", Object.assign({ ref: ref1, className: classnames_1.default(wrapperClassName, 'w-100 position-relative d-f flex-row of-x-hidden') }, { children: [jsx_runtime_1.jsx(design_system_1.BodyText, Object.assign({}, props, { className: classnames_1.default(props.className, Styles.mainText, {
                    [Styles.mainTextHidden]: limited,
                }), ref: ref2 }, { children: children }), void 0), limited && (jsx_runtime_1.jsxs("div", Object.assign({ className: Styles.moreDetailsWrapper }, { children: [jsx_runtime_1.jsx(design_system_1.BodyText, Object.assign({}, props, { className: classnames_1.default(props.className, Styles.moreDetailsText, 't-truncate') }, { children: children }), void 0), jsx_runtime_1.jsx(design_system_1.MoreDetails, { full: children !== null && children !== void 0 ? children : '', short: "", size: props.size }, void 0)] }), void 0))] }), void 0));
};
exports.BodyTextLine = BodyTextLine;
const HeadlineLine = (_a) => {
    var { children, wrapperClassName } = _a, props = __rest(_a, ["children", "wrapperClassName"]);
    const [ref1, ref2, limited] = useLimited();
    return (jsx_runtime_1.jsxs("div", Object.assign({ ref: ref1, className: classnames_1.default(wrapperClassName, 'w-100 position-relative d-f flex-row') }, { children: [jsx_runtime_1.jsx(design_system_1.Headline, Object.assign({}, props, { className: classnames_1.default(props.className, Styles.mainText, {
                    [Styles.mainTextHidden]: limited,
                }), ref: ref2 }, { children: children }), void 0), limited && (jsx_runtime_1.jsxs("div", Object.assign({ className: Styles.moreDetailsWrapper }, { children: [jsx_runtime_1.jsx(design_system_1.Headline, Object.assign({}, props, { className: classnames_1.default(props.className, Styles.moreDetailsText, 't-truncate') }, { children: children }), void 0), jsx_runtime_1.jsx(design_system_1.MoreDetails, { full: children !== null && children !== void 0 ? children : '', short: "" }, void 0)] }), void 0))] }), void 0));
};
exports.HeadlineLine = HeadlineLine;
//# sourceMappingURL=line-text.js.map